const navigationItems = [
    {
      label: "Careers",
      groups: [
        {
          label: "Global Careers",
          href: "/careers",
        },
        {
          label: "Our Brands",
          href: "/careers/our-brands-group",
          children: [
            {
              label: "Columbia",
              href: "/careers/our-brands-group/?tab-78baa3e833ecb8b09e4",
            },
            {
              label: "SOREL",
              href: "/careers/our-brands-group/?tab-9d37deaf387dfeb99f5",
            },
            {
              label: "Mountain Hardwear",
              href: "/careers/our-brands-group/?tab-7f9133205962d06a60c",
            },
            {
              label: "prAna",
              href: "/careers/our-brands-group/?tab-05cf9eb2b0103558eb1",
            }
          ]
        },
        // {
        //   label: "Our Regions & Locations",
        //   href: "#",
        //   children: [
        //     {
        //       label: "North America",
        //       href: "#",
        //     },
        //     {
        //       label: "Asia",
        //       href: "#",
        //     },
        //     {
        //       label: "Europe",
        //       href: "#",
        //     }
        //   ]
        // }
      ]
    },
    {
      label: "Our Company",
      children: [
        // {
        //   label: "About Us",
        //   href: "#"
        // },
        {
          label: "Inclusion & Diversity",
          href: "/our-company/inclusion-diversity"
        },
        {
          label: "Leadership",
          href: "/our-company/leadership"
        },
        {
          label: "Our History",
          href: "/our-company/our-history"
        },
        {
          label: "Strategy, Mission & Values",
          href: "/our-company/strategy-mission-values"
        },
        // {
        //   label: "Wellbeing & Benefits",
        //   href: "#"
        // }
      ]
    },
  {
    label: "Corporate Responsibility",
    children: [
      {
        label: "Overview",
        href: "/corporate-responsibility-group"
      },
      // {
      //   label: "Empowering People",
      //   href: "#"
      // },
      // {
      //   label: "Sustaining Places",
      //   href: "#"
      // },
      {
        label: "Responsible Practices",
        href: "/corporate-responsibility/responsible-practices"
      },
      // {
      //   label: "Highlights",
      //   href: "#"
      // }
    ]
  },
  {
    label: "News",
    children: [
      {
        label: "Press Releases",
        href: "https://investor.columbia.com/news-events/press-releases",
        isExternal: true
      },
      // {
      //   label: "Feature Stories",
      //   href: "#"
      // }
    ]
  },
  {
    label: "Investor Relations",
    href: "https://investor.columbia.com/",
    isExternal: true
  },
  {
    label: "Shop",
    children: [
      {
        label: "Columbia",
        href: "https://www.columbia.com",
        isExternal: true
      },
      {
        label: "Mountain Hardwear",
        href: "https://www.mountainhardwear.com/",
        isExternal: true
      },
      {
        label: "SOREL",
        href: "https://www.sorel.com/",
        isExternal: true
      },
      {
        label: "prAna",
        href: "https://www.prana.com/",
        isExternal: true
      },
    ]
  }
];

export default navigationItems;
